import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$companySlug/admin/users/")({
  component: () => null,
});
